import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div``;

const EventBookerRenderer = ({ rowData, columnData: { mappedAdmins } }) => {
  const { summarized, subRows } = rowData;

  if (summarized || subRows) {
    return <></>;
  }

  const { firstName, lastName } = mappedAdmins?.[rowData.bookerId] || {};

  return <Wrapper>{[firstName, lastName].filter(Boolean).join(' ')}</Wrapper>;
};

export default EventBookerRenderer;
